import { AxiosError } from "axios";

/**
 * Erro de API com `code`/`status` opcionais anexados, pra quem precisar decidir algo na UI
 * além do texto (ex.: desabilitar um botão específico quando `code === "SOME_CODE"`).
 * Continua sendo um `Error` normal pra todo o resto do código que só faz `instanceof Error`.
 */
export class ApiError extends Error {
	code?: string;
	status?: number;

	constructor(message: string, options?: { code?: string; status?: number }) {
		super(message);
		this.name = "ApiError";
		this.code = options?.code;
		this.status = options?.status;
	}
}

export const extractApiErrorMessage = (error: unknown, fallback: string): ApiError => {
	if (error instanceof AxiosError) {
		const status = error.response?.status;
		const body = error.response?.data as { message?: string; code?: string } | undefined;

		if (typeof body?.message === "string") {
			return new ApiError(body.message, { code: body.code, status });
		}

		if (status === 409) {
			return new ApiError("Esse registro foi alterado por outra ação enquanto você trabalhava nele. Recarregue e tente novamente.", {
				code: body?.code,
				status,
			});
		}

		return new ApiError(fallback, { code: body?.code, status });
	}

	return new ApiError((error as { message?: string })?.message || fallback);
};
